import { router, usePage } from "@inertiajs/react";
import { useEffect, useRef } from "react";
import { toast } from "sonner";
import type { FlashData } from "@/types";

function showFlash(flash?: FlashData) {
  toast.dismiss();
  if (flash?.alert) {
    toast.error(flash.alert);
  }
  if (flash?.notice) {
    toast.success(flash.notice);
  }
}

export const useFlash = () => {
  const { props } = usePage();
  const initialFlash = useRef(props.flash as FlashData | undefined);

  useEffect(() => {
    showFlash(initialFlash.current);
    // Inertia preserves equal prop references, including identical notices from
    // consecutive saves at the same URL. Completed visits identify new feedback.
    const removeListeners = [
      router.on("start", () => toast.dismiss()),
      router.on("success", (event) =>
        showFlash(event.detail.page.props.flash as FlashData | undefined),
      ),
      router.on("error", (event) => {
        if (event.detail.page) {
          showFlash(event.detail.page.props.flash as FlashData | undefined);
        }
      }),
      router.on("navigate", (event) => {
        if (event.detail.type === "history") toast.dismiss();
      }),
      router.on("clientVisit", () => toast.dismiss()),
    ];
    return () => removeListeners.forEach((remove) => remove());
  }, []);
};
